var _path, _ellipse, _ellipse2, _ellipse3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconAnswer = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.28 2.05H5.76A1.73 1.73 0 004 3.77v12.28a1.72 1.72 0 001.72 1.72H8a.23.23 0 01.07.15 6.77 6.77 0 01-.55 2.42l-.82 1.91 1.87-.91a11.69 11.69 0 003.88-3.51.16.16 0 01.09 0h5.76a1.72 1.72 0 001.7-1.75V3.77a1.73 1.73 0 00-1.72-1.72zM5.76 3.59h12.52a.19.19 0 01.18.18v12.31a.18.18 0 01-.18.18h-5.79a1.64 1.64 0 00-1.28.61l-.2.25a13.6 13.6 0 01-1.45 1.59l-.07.07v-.22-.62a1.78 1.78 0 00-.42-1.16 1.62 1.62 0 00-1.21-.55h-2.1a.18.18 0 01-.18-.18V3.77a.19.19 0 01.18-.18z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.13,
  cy: 10.05,
  rx: 1.06,
  ry: 1.08
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.18,
  cy: 10.05,
  rx: 1.06,
  ry: 1.08
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.22,
  cy: 10.05,
  rx: 1.06,
  ry: 1.08
})));

export default SvgIconAnswer;